import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-ea743328"), n = n(), _popScopeId(), n);
const _hoisted_1 = {
  class: "SystemSettingViewContainer"
};
const _hoisted_2 = {
  class: "wd100 border flex flex-col pd12 flex items-center justify-center"
};
const _hoisted_3 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", {
  class: "boldFont"
}, "默认回看天数设置", -1));
const _hoisted_4 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "天后不能回看", -1));
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_DifficultySettings = _resolveComponent("DifficultySettings");
  const _component_el_tab_pane = _resolveComponent("el-tab-pane");
  const _component_el_input = _resolveComponent("el-input");
  const _component_el_col = _resolveComponent("el-col");
  const _component_el_row = _resolveComponent("el-row");
  const _component_el_button = _resolveComponent("el-button");
  const _component_el_tabs = _resolveComponent("el-tabs");
  return _openBlock(), _createElementBlock("div", _hoisted_1, [_createVNode(_component_el_tabs, {
    modelValue: $data.activeName,
    "onUpdate:modelValue": _cache[2] || (_cache[2] = $event => $data.activeName = $event),
    class: "demo-tabs"
  }, {
    default: _withCtx(() => [_createVNode(_component_el_tab_pane, {
      label: "自由练习难度设置",
      name: "practice"
    }, {
      default: _withCtx(() => [$data.practice ? (_openBlock(), _createBlock(_component_DifficultySettings, {
        key: 0,
        data: $data.practice,
        type: "PRACTICE"
      }, null, 8, ["data"])) : _createCommentVNode("", true)]),
      _: 1
    }), _createVNode(_component_el_tab_pane, {
      label: "课上难度设置",
      name: "onclass"
    }, {
      default: _withCtx(() => [$data.onclass ? (_openBlock(), _createBlock(_component_DifficultySettings, {
        key: 0,
        data: $data.onclass,
        type: "ON_CLASS"
      }, null, 8, ["data"])) : _createCommentVNode("", true)]),
      _: 1
    }), _createVNode(_component_el_tab_pane, {
      label: "其他系统设置",
      name: "system"
    }, {
      default: _withCtx(() => [_createVNode(_component_el_row, {
        class: "flex items-center"
      }, {
        default: _withCtx(() => [_createVNode(_component_el_col, {
          span: 6,
          class: "flex items-center"
        }, {
          default: _withCtx(() => [_createElementVNode("div", _hoisted_2, [_hoisted_3, _createVNode(_component_el_row, {
            class: "flex items-center justify-center mt16"
          }, {
            default: _withCtx(() => [_createVNode(_component_el_col, {
              span: 12,
              class: "flex items-center"
            }, {
              default: _withCtx(() => [_createVNode(_component_el_input, {
                placeholder: "天",
                type: "number",
                min: "1",
                modelValue: $data.system.DEFAULT_EXAM_HISTORY_REVIEW,
                "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => $data.system.DEFAULT_EXAM_HISTORY_REVIEW = $event)
              }, null, 8, ["modelValue"])]),
              _: 1
            }), _createVNode(_component_el_col, {
              span: 12,
              class: "flex justify-end items-center"
            }, {
              default: _withCtx(() => [_hoisted_4]),
              _: 1
            })]),
            _: 1
          }), _createVNode(_component_el_row, {
            class: "mt16 flex items-center justify-center"
          }, {
            default: _withCtx(() => [_createVNode(_component_el_button, {
              type: "primary",
              onClick: _cache[1] || (_cache[1] = $event => $options.updateSetting('DEFAULT_EXAM_HISTORY_REVIEW'))
            }, {
              default: _withCtx(() => [_createTextVNode("更新回看天数设置")]),
              _: 1
            })]),
            _: 1
          })])]),
          _: 1
        })]),
        _: 1
      })]),
      _: 1
    })]),
    _: 1
  }, 8, ["modelValue"])]);
}